import React from 'react';
import { CourseCertificateTag } from './styles';

export function ModuleCertificateAwardTag() {
    return <CourseCertificateTag>
        <i className="bi bi-award"></i> Este módulo oferece certificado!
    </CourseCertificateTag>;
}
